function LayerIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7899 11.88C11.2499 11.88 10.6999 11.78 10.2699 11.59L4.3699 8.97C2.8699 8.3 2.6499 7.4 2.6499 6.91C2.6499 6.42 2.8699 5.52 4.3699 4.85L10.2699 2.23C11.1399 1.84 12.4499 1.84 13.3199 2.23L19.2299 4.85C20.7199 5.51 20.9499 6.42 20.9499 6.91C20.9499 7.4 20.7299 8.3 19.2299 8.97L13.3199 11.59C12.8799 11.79 12.3399 11.88 11.7899 11.88ZM11.7899 3.44C11.4499 3.44 11.1199 3.49 10.8799 3.6L4.9799 6.22C4.3699 6.5 4.1499 6.78 4.1499 6.91C4.1499 7.04 4.3699 7.33 4.9699 7.6L10.8699 10.22C11.3499 10.43 12.2199 10.43 12.6999 10.22L18.6099 7.6C19.2199 7.33 19.4399 7.04 19.4399 6.91C19.4399 6.78 19.2199 6.49 18.6099 6.22L12.7099 3.6C12.4699 3.5 12.1299 3.44 11.7899 3.44Z"
        fill="#292D32"
        className="fill"
      />
      <path
        d="M12 17.09C11.62 17.09 11.24 17.01 10.88 16.85L4.09 13.83C3.06 13.38 2.25 12.13 2.25 11C2.25 10.59 2.59 10.25 3 10.25C3.41 10.25 3.75 10.59 3.75 11C3.75 11.55 4.2 12.24 4.7 12.47L11.49 15.49C11.81 15.63 12.18 15.63 12.51 15.49L19.3 12.47C19.8 12.25 20.25 11.55 20.25 11C20.25 10.59 20.59 10.25 21 10.25C21.41 10.25 21.75 10.59 21.75 11C21.75 12.13 20.94 13.38 19.91 13.84L13.12 16.86C12.76 17.01 12.38 17.09 12 17.09Z"
        fill="#292D32"
        className="fill"
      />
      <path
        d="M12 22.09C11.62 22.09 11.24 22.01 10.88 21.85L4.09 18.83C2.97 18.33 2.25 17.22 2.25 15.99C2.25 15.58 2.59 15.24 3 15.24C3.41 15.24 3.75 15.59 3.75 16C3.75 16.63 4.12 17.21 4.7 17.47L11.49 20.49C11.81 20.63 12.18 20.63 12.51 20.49L19.3 17.47C19.88 17.21 20.25 16.64 20.25 16C20.25 15.59 20.59 15.25 21 15.25C21.41 15.25 21.75 15.59 21.75 16C21.75 17.23 21.03 18.34 19.91 18.84L13.12 21.86C12.76 22.01 12.38 22.09 12 22.09Z"
        fill="#292D32"
        className="fill"
      />
    </svg>
  );
}

export default LayerIcon;
